// @flow

import Analytics from "@cabonline/shared/utils/Analytics"
import AuthStore from "shared/stores/AuthStore"
import { isProductionBuild, isProductionApi } from "@cabonline/shared/utils/env"
import { googleAnalyticsTrackingId } from "shared/utils/constants"

class LocalAnalytics extends Analytics {
  startTracking(history) {
    if (!googleAnalyticsTrackingId) return

    if (isProductionApi && isProductionBuild) {
      this.init(googleAnalyticsTrackingId, history)
    }
  }
  logInteraction(action, label = "") {
    this.sendEventToGA("Interaction", action, 0, label)
  }
}

export default (new LocalAnalytics(AuthStore): any)
